var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "custom-itl__img",
    viewBox: "0 0 28 28"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001138",
    fillRule: "evenodd",
    d: "M17.27 11.62h-2.13v-1.4a.57.57 0 0 1 .59-.65h1.51V7.26h-2.08a2.63 2.63 0 0 0-2.83 2.83v1.54H11V14h1.33v6.75h2.81V14H17Z"
  })));
};
export default SvgFacebook;